<div class="sectionb">

    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <ng-container *ngIf="!ismodal">
        <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2">
            <div><span class="navbar-brand mb-0 h1"><i class="fas fa-dice-d6"></i> Supervision Data</span></div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="navbar-nav ml-auto">
<!-- *permusr="{resourceId:controlEnum.BTN_SUPERVISION_EDIT,permusrAuthFunction:uiShowSaveBtn()}" -->
                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item mr-1" *ngIf="uiShowSaveBtn(controlEnum.BTN_SUPERVISION_EDIT)">
                            <button matTooltip="Save data" type="button" class="btn btn-sm  btn-success "
                                [disabled]="!myform.valid||submitted" (click)="saveModel()">
                                <i class="far fa-save"></i> Save
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </ng-container>

    <form [formGroup]="myform" class="container-fluid" (ngSubmit)="saveModel()">
        <p class="form-hint">Fields with * are required</p>
        <div class="form-group row" *ngIf="canChangeSite">
            <label class="col-sm-3 col-form-label" for="description"><span class="required-asterisk">*</span>Site</label>
            <div class="col-sm-9">
                <select id="site" formControlName="site" class="form-control form-control-sm" [compareWith]="optionlist_comparesite" required
                        [ngClass]="!myform.get('site').valid ? 'is-invalid' :'' ">
                    <option [ngValue]="null" disabled>Select site for supervision</option>
                    <option *ngFor="let asite of sites" [ngValue]="asite">
                        {{ asite.name}}
                    </option>
                </select>
                <div class="invalid-feedback" *ngIf="myform.get('site').hasError('required')">
					Site is required.
				</div>
            </div>
        </div>
        <div class="form-group row">
            
            <label class="col-sm-3 col-form-label" for="name"><span class="required-asterisk">*</span>Supervision name</label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="name" formControlName="name" type="text" required
                    placeholder="Enter supervision name" [ngClass]="!myform.get('name').valid ? 'is-invalid' :'' ">
                <div class="invalid-feedback" *ngIf="myform.get('name').hasError('required')">
                    Name is required
                </div>
                <div class="invalid-feedback" *ngIf="myform.get('name').hasError('minlength')">
                    Name must be at least 3 characters long.
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="scheduledDate"><span class="required-asterisk">*</span>Scheduled Date </label>
            <div class="col" >
                       <mat-form-field  class="mat-form-control-sm" style="max-width: 16em;">
                        <input matInput [matDatepicker]="datepickerschd" formControlName="scheduledDate" required (dateInput)="scheduledDate_change($event)">
                        <mat-datepicker-toggle matSuffix [for]="datepickerschd"></mat-datepicker-toggle>
                        <mat-datepicker #datepickerschd ></mat-datepicker>
                      </mat-form-field>               
                <div class="invalid-feedback" *ngIf="myform.get('scheduledDate').hasError('required')">
                    Date is incorrect
                </div>
                <div class="input-hint">Day expected to start supervision.</div> 
            </div>
        </div>         
        <div class="form-group row" *ngIf="!isnewmodel">
            <label class="col-sm-3 col-form-label" for="supervisionDate">Supervision Date </label>
            <div class="col" >
                       <mat-form-field  class="mat-form-control-sm disabledreadable" style="max-width: 16em;">
                        <input matInput class="mat-form-field disabledreadable" [matDatepicker]="picker2" formControlName="supervisionDate" required disabled>
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        
                      </mat-form-field>    
                      <div class="input-hint">Supervision Date is calculated automatically with images used by system</div>           
            </div>
        </div>   
        
        <div class="form-group row">           
            <div class="col-sm-3 ">
                 <label class="col-form-label" for="description">Description</label>
                <div class="input-hint">Information about the supervision. </div>
             </div>
            <div class="col-sm-9">
                <textarea class="form-control form-control-sm" id="description" formControlName="description" rows="4"
                    placeholder="Description about requirements for supervision..."></textarea>
            </div>
        </div>
           
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="emissivity"><span class="required-asterisk">*</span>Emissivity </label>
            <div class="col-sm-2" style="max-width: 16em;">
                <input class="form-control form-control-sm" id="emissivity" formControlName="emissivity" type="number" required
                    min="0" max="1" step="0.1"
                    placeholder="Enter emissivity of supervision"
                    [ngClass]="!myform.get('emissivity').valid ? 'is-invalid' :'' ">
                <div class="invalid-feedback" *ngIf="myform.get('emissivity').hasError('required')">
                    emissivity is required between 0 and 1
                </div>
            </div>
        </div>
<!--         <div class="form-group row">           
            <div class="col-sm-3 ">
                 <label class="col-form-label" for="drone_comments">Drone comments</label>
                <div class="input-hint">Provide public information for drone pilots. </div>
             </div>
            <div class="col-sm-9">
                <textarea class="form-control form-control-sm" id="drone_comments" formControlName="drone_comments" rows="4"
                    placeholder="Description about requirements for supervision..."></textarea>
            </div>
        </div>   
        <div class="form-group row" *ngIf="!isnewmodel">
            <div class="col-sm-3 ">
               <label class="col-form-label" for="results_comments">Results comments</label> 
               <div class="input-hint">Enter comments to results.</div>
            </div>
            
            
            <div class="col-sm-9">
                <textarea class="form-control form-control-sm" id="results_comments" formControlName="results_comments" rows="4"
                    placeholder="Comments about results for supervision..."></textarea>
            </div>
        </div> -->

    </form>
</div>